import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../../../assets/scss/components/signup.scss";
import RightArrow from "../../../assets/images/right-arrow.svg";
import NuvamaIcon from "../../../assets/images/nuvama-icon.png";
import FinTech from "../../../assets/images/FinTech.svg";
import Individual from "../../../assets/images/Individual.svg";
import SignupForm from "../../../components/ClientComponents/Signup/SignupForm";
import debounce from "../../../components/utils/debounce";
import { alphabetExp, integerExp } from "../../../components/utils/regex";
import { AGetCities } from "../../../services/login/loginApiService";
import { signFormSubmit } from "../../../services/Signup/SignupApiServices";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import {
  accRedircet,
  fnBrowserDetect,
  getDevice,
} from "../../../services/genralServise";
import { config } from "../../../config/domain";
import { constants, removeServerErrors } from "../../Constants/commenFeatures";
import { ModalOpenFor, SIGNUPFORM, SIGNUPFORMERR } from "./constent";
import LoginFormBtmTxt from "../../../components/login/generic/loginFormBtmTxt";
import { RoutesUrl } from "../../Routes/constents";
import useDocumentTitle from "../../../utils/useDocumentTitle";

const Signup = () => {
  const [signUpModal, setSignUpModal] = useState({
    isOpen: false,
    openFor: "",
  });
  const history = useHistory();
  const [clientCode, setClientCode] = useState("");
  const [cities, setCities] = useState(null);
  const [signupFormVal, setSignupFormVal] = useState(
    JSON.parse(JSON.stringify(SIGNUPFORM))
  );
  const [signupErr, setSignupErr] = useState(
    JSON.parse(JSON.stringify(SIGNUPFORMERR))
  );
  useDocumentTitle("Sign up");
  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });

  const submitSignupFormRes = (res) => {
    if (res && res.data) {
      setIsServerErr({
        ...isServerErr,
        successRes:
          "Your request for call has been submitted. We will get back to you shortly.",
      });
      setCities(null);
      setSignupFormVal(JSON.parse(JSON.stringify(SIGNUPFORM)));
    } else {
      setIsServerErr({
        ...isServerErr,
        failedRes: "Request failed, please try again after some time.",
      });
    }
  };

  const submitSignupForm = (e) => {
    e.preventDefault();
    setSignUpModal(false);
    let Body = {
      nm: signupFormVal.nm,
      em: signupFormVal.eml,
      mob: signupFormVal.phNo,
      mod: "Client",
      rtg: 0,
      opt: signupFormVal.city,
      cmmt: `Client requested a callback , Client Code - ${
        clientCode ? clientCode : null
      }`,
      dev: getDevice(),
      pg: "Signup page",
      url: `${config.root}/signup`,
      ptf: "API connect",
      imgs: [],
      brw: fnBrowserDetect(),
      accode: "Guest User",
    };
    console.log("signupFormVal", Body);

    signFormSubmit(submitSignupFormRes, Body);
  };

  function onChangeSignupForm(key, value) {
    // onchange of any field remove both type of errors
    if (key === "city") {
      // separate city and state (state is blank string if not present in the value)
      const [city, state = ""] = value.split(";");
      setSignupFormVal({
        ...signupFormVal,
        city: city.replace(/\w\S*/g, (w) =>
          w.replace(/^\w/, (c) => c.toUpperCase())
        ),
        state: state.replace(/\w\S*/g, (w) =>
          w.replace(/^\w/, (c) => c.toUpperCase())
        ),
      });

      // if city length is greater than 2, then call the api with debounce of 300ms
      if (city.length > 2) {
        debounce(() => getCities(value), 300)();
      }
    } else {
      if (
        (key === "nm" && !alphabetExp.test(value)) ||
        (key === "phNo" && !integerExp.test(value))
      ) {
        value = signupFormVal[key];
      }
      setSignupFormVal({ ...signupFormVal, [key]: value });
    }
    setSignupErr({ ...signupErr, [key]: "" });
    if (key === "clCode" && value === "") {
      delete signupFormVal.clCode;
    }
    return value;
  }
  function getCities(srchStr) {
    AGetCities(getCitiesRes, srchStr);
  }

  function getCitiesRes(res) {
    if (res.data && res.data.ctyLst) {
      setCities(res.data.ctyLst);
    }
  }

  function handleACBlur(value: any) {
    if (!value) {
      setSignupErr({
        ...signupErr,
        city: "Please enter atleast 3 characters of city name",
      });
    } else if (value.split(";").length !== 2) {
      setSignupErr({
        ...signupErr,
        city: "Please enter a valid city name",
      });
    }
  }

  function onClear(cb) {
    cb("");
  }

  const show_modal = (isOpen, openFor) => {
    setSignUpModal({
      isOpen: isOpen,
      openFor: openFor,
    });
    if (openFor === ModalOpenFor.Individual) {
      delete signupFormVal.compName;
    } else {
      signupFormVal.compName = "";
    }
    setSignupErr(SIGNUPFORMERR);
  };

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };
  useEffect(() => {
    if (
      isServerErr.successRes !== "" ||
      isServerErr.failedRes !== "" ||
      isServerErr.limitExceeded !== ""
    ) {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  return (
    <div>
      <ErrorMsg isServerErr={isServerErr} />
      <div className="signup_container">
        <div className="signup">
          <div className="signup_head">
            <h1>How would you like to join us?</h1>
          </div>
          <ul role="list" className="signup_list">
            <li>
              <button
                className="signup_display"
                onClick={() => show_modal(true, ModalOpenFor.Individual)}
                aria-label="Individual – For retail users looking to simplify or automate their trading"
              >
                <img src={Individual} alt="" aria-hidden="true"  />
                <div>
                  <h2>Individual</h2>
                  <p>For retail users looking to simplify</p>
                  <p>or automate their trading</p>
                </div>
                <img src={RightArrow}  alt="" aria-hidden="true" />
              </button>
            </li>
            <li>
              <button
                className="signup_display"
                onClick={() => history.push(RoutesUrl.VendorReqACall)}
                aria-label="Start-up / FinTech – For tech companies building innovative investment and trading platforms"
              >
                <img src={FinTech} alt="" aria-hidden="true" />
                <div>
                  <h2>Start-up/FinTech</h2>
                  <p>For tech giant building innovative</p>
                  <p>investment & trading platform</p>
                </div>
                <img src={RightArrow} alt="" aria-hidden="true" />
              </button>
            </li>
            <li>
              <button
                className="signup_display"
                onClick={() => history.push(RoutesUrl.ClientLogin)}
                aria-label="Already a Nuvama Client? – Login using the same credentials and get started immediately"
              >
                <img className="nuvama-icon" src={NuvamaIcon} alt="" aria-hidden="true" />
                <div>
                  <h2>Already Nuvama Client?</h2>
                  <p>Login using the same credentials</p>
                  <p>and get started immediately</p>
                </div>
                <img src={RightArrow} alt="" aria-hidden="true" />
              </button>
            </li>
          </ul>



          <LoginFormBtmTxt />
        </div>

        {/* Modal box */}

        <SignupForm
          signupModal={signUpModal}
          show_modal_Fun={show_modal}
          onChangeSignupForm={onChangeSignupForm}
          handleACBlur={handleACBlur}
          signupErr={signupErr}
          setSignupErr={setSignupErr}
          cities={cities}
          signupFormVal={signupFormVal}
          submitSignupForm={submitSignupForm}
          onClear={onClear}
          clientCode={clientCode}
          setClientCode={setClientCode}
        />
      </div>
    </div>
  );
};

export default Signup;
